export enum ScreenSize {
    XSmall = 'xs',
    Small = 'sm',
    Medium = 'md',
    Large = 'lg',
    XLarge = 'xl',
    Unknown = 'Unknown'
}
